export default __webpack_public_path__ + "static/media/info.2ac30d26.svg";